import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './style.css';
import { AuthProvider } from "./modules/Mobile/helper/AuthContext";
import ErrorBoundary from "./ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
 <AuthProvider>
      <App />
    </AuthProvider>
    </ErrorBoundary>
   
  </React.StrictMode>
);